import axios from "axios";
import toast from "react-hot-toast";
import { store } from "../redux/store"; // apne path ke hisaab se adjust karo
import { logout } from "../redux/reducers/authSlice";

export const appServiceName = process.env.REACT_APP_WEBSITE_URL;

// ✅ Axios Instance
const http = axios.create({
  baseURL: appServiceName,
});

//feat: Enhance attendance regularization API with store, get, approve, and deny functionalities
// ===============================
// ✅ REQUEST INTERCEPTOR
// Har request se pehle chalega
// ===============================
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }

    return config;
  },
  (error) => Promise.reject(error)
);


// ===============================
// ✅ RESPONSE INTERCEPTOR
// 401 handle karega
// ===============================
http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 🔥 Token expired / invalid

      localStorage.removeItem("token");

      store.dispatch(logout());

      toast.error("Token expired. Please login again.");

      //   window.location.href = "/";
      navigate("/");
    }

    return Promise.reject(error);
  }
);


// ===============================
// ✅ Generic API Methods
// ===============================
const RestfulProvider = {
  get: (url, params = {}) =>
    http.get(url, { params }).then((res) => res.data),

  post: async (url, data) => {
    const isFormData = data instanceof FormData;

    const res = await http.post(url, data, {
      headers: isFormData ? {} : { "Content-Type": "application/json" },
    });
    return res.data;
  },

  put: (url, data) =>
    http.put(url, data).then((res) => res.data),

  delete: (url, data) =>
    http.delete(url, { data }).then((res) => res.data),
};


export default RestfulProvider;

